'use strict'
let login_btn_go = document.querySelector('.login')
let signup_btn_go = document.querySelector('.signup')
let signup_btn = document.querySelector('.signup-btn')
let forgot_btn = document.querySelector('.forgotPass-btn')
let login_btn_in_signupPage = document.querySelector('.signup-login_btn')

const expressServer = `https://zone-node-env.eba-b2mmma2b.us-east-1.elasticbeanstalk.com`

// const expressServer = `http://127.0.0.3:5500`

const frontEndUrl = `http://${document.location.hostname}:${document.location.port}`

const popup = function (message) {
  document.querySelector('body').insertAdjacentHTML('beforebegin', `<div class="pop-up-notification">
  <img class="" title="Notifications" src="/notification.png" alt="logo">
  <p>${message}</p>
  </div>`)

  setTimeout(function () {
    document.querySelector('.pop-up-notification').classList.add('hide')
    document.querySelector('.pop-up-notification').remove()
  }, 3000)
}

signup_btn.addEventListener('click', function (e) {
  e.preventDefault()
  document.querySelector('.login_cont').classList.add('hide')
  document.querySelector('.signup_cont').classList.remove('hide')
  document.querySelector('.forgot_cont').classList.add('hide')
})

login_btn_in_signupPage.addEventListener('click', function (e) {
  e.preventDefault()
  document.querySelector('.login_cont').classList.remove('hide')
  document.querySelector('.signup_cont').classList.add('hide')
  document.querySelector('.forgot_cont').classList.add('hide')
})

forgot_btn.addEventListener('click', function (e) {
  e.preventDefault()
  document.querySelector('.forgot_cont').classList.remove('hide')
  document.querySelector('.signup_cont').classList.add('hide')
  document.querySelector('.login_cont').classList.add('hide')
})


let usernameInput = document.querySelector('.login-username')
let passwordInput = document.querySelector('.login-pass')
let loginbtn = document.querySelector('.login')




loginbtn.addEventListener('click', function (e) {
  e.preventDefault()
  loginbtn.textContent = `Loading`
  fetch(`${expressServer}/login/1680/${usernameInput.value}/${passwordInput.value}`).then(function (e) {
    if (e.status === 404) {
      throw new Error("Invalid Username or Password")
    }
    else {
      return e.json()
    }
  }).then(function (data) {
    localStorage.setItem("zonetoken", data.token)
    localStorage.setItem("zoneusername", data.username)
    document.location.href = `${frontEndUrl}/home.html`
  }).catch(function (err) {
    loginbtn.textContent = `Go`
    popup(`${err || "Internal Server Error"}`)
  })
})


let sUsername = document.querySelector(".signup-username")
let sPass = document.querySelector(".signup-pass")
let sEmail = document.querySelector(".signup-email")
let sDOB = document.querySelector(".signup-dob")
let sFullname = document.querySelector(".signup-fullname")



//Signup 
document.querySelector(".signup").addEventListener("click", function (e) {
  e.preventDefault()
  if (!sUsername.value || !sPass.value || !sEmail.value || !sDOB.value || !sFullname.value) return popup("Please provide all fields")

  document.querySelector(".signup").textContent = "Loading"

  let obj = {
    name: sFullname.value,
    email: sEmail.value,
    username: sUsername.value,
    dateOfBirth: "12/7/1992",
    password: sPass.value,
    photo: "",
    about: "Random",
    tweets: [],
    retweets: [
    ],
    likedTweets: [
    ],
    followers: [
    ],
    following: [
    ],
    notifications: [],
    conversations: []
  }

  fetch(`${expressServer}/signup/1680`, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify(obj)
  }).then(function (e) {
    if (e.status === 404) throw new Error("Could not register user")

    popup("Welcome to Zone! You can now login...")

    setTimeout(function () {
      document.location.reload()
    }, 1500)

  }).catch(function (err) {
    popup(`${err || "Internal Server Error"}`)
    document.querySelector(".signup").textContent = "GO"
  })
})




//forgot password

document.querySelector(".forgot").addEventListener("click", function (e) {
  e.preventDefault()
  if (!document.querySelector(".forgot-email").value) return popup("Please enter your email address")

  document.querySelector(".forgot").textContent = "Loading"

  fetch(`${expressServer}/pass/1680/${document.querySelector(".forgot-email").value}`).then(function (e) {
    if (e.status === 404) throw new Error(
      "Internal Server Error")

    popup("Email sent succesfully")
    setTimeout(function () {
      document.location.reload()
    }, 2000)

  }).catch(function (err) {
    popup(`${err || "Error sending email"}`)
    document.querySelector(".forgot").textContent = "Reset Password"
  })
})